import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import { useTheme } from 'expo-router/react-navigation'
import { Stack, type NativeStackNavigationOptions } from 'expo-router'
import { Platform } from 'react-native'

export default function NotificationsLayout() {
  const theme = useTheme()

  return (
    <Stack
      screenOptions={{
        title: '',
        headerLargeTitle: true,
        headerShadowVisible: false,
        headerBackButtonDisplayMode: 'minimal',
        contentStyle: { backgroundColor: theme.colors.background },
        ...Platform.select<NativeStackNavigationOptions>({
          ios: {
            headerTransparent: true,
            ...(isBelowiOS26 ? { headerBlurEffect: 'systemChromeMaterial' as const } : {}),
          },
          android: {
            headerTransparent: false,
            headerStyle: { backgroundColor: theme.colors.background },
          },
        }),
      }}
    >
      <Stack.Screen name="index" options={{ title: '通知' }} />
    </Stack>
  )
}
